import React from 'react';
import { Redirect } from 'react-router-dom';

const SupportRedirect = () => {
    return <Redirect to="/support" />;
};

export default SupportRedirect;
